import { Attributes, LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class ParticipantContactDetailsLookup extends LookupBase {

    public firstName: string = "";

    public lastName: string = "";

    @Attributes.Observable()
    public correspondenceEmail: string = "";
    
    @Attributes.Observable()
    public correspondenceMobileNumber: string = "";

    // Client only properties / methods
}